<template>
  <div class="page">
    <navigator-menu></navigator-menu>
    <div style="color: black;position: absolute; top: 28vh; left: 15vw;width: 70vw; font-size: 60px; font-weight: 1000;"
         class="wow fadeInLeft" data-wow-duration="1.5s" data-wow-delay="0.05s">
      ITAKE<br>
      Rebuild your world!
    </div>
    <div style="color: grey;position: absolute; top: 55vh; left: 15vw;width: 70vw;"
      class="wow bounceInUp" data-wow-duration="1.5s" data-wow-delay="0.05s">
      <el-icon :size=100 style="margin-left:40px; color: #ffd04b"><right /></el-icon>
      <div style="font-size: 30px; font-weight: 1000; color: #ffd04b">Click to start</div>
    </div>
    <el-button size="200px" color="#ffd04b" class="wow bounceInUp" data-wow-duration="1.5s" data-wow-delay="0.05s" style="margin-top: -40px; border-radius: 50%; height: 6vw; width: 6vw; min-width: 6vw; color: chocolate; font-size: 40px" @click="showProjects">Click!</el-button>
    <el-backtop class="wow bounceInRight"/>
  </div>
</template>

<script>
import NavigatorMenu from "./Navigation";
// import NavigatorMenuMobile from "../components/NavigatorMenuMobile";
import WOW from "wow.js";
import axios from 'axios'
export default {
  name: "Home",
  components: {
  //   AdvSearch,
  //   NavigatorMenuMobile,
    NavigatorMenu,
  //   Edit,
  //   Swiper
  },
  data(){
    return{
      searchWord: '',
      csrfToken:"",
      Search: require("@element-plus/icons/lib/Search"),
      searchStyle: 'font-size:23px; height: 10.5vh; width: 70vw; border-radius: 35px;overflow:hidden;',
    }
  },
  created() {
    var strcookie = document.cookie;//获取cookie字符串
    var arrcookie = strcookie.split("; ");//分割
    //遍历匹配
    for ( var i = 0; i < arrcookie.length; i++) {
      var arr = arrcookie[i].split("=");
      if (arr[0] == "csrftoken"){
        this.csrfToken = arr[1];
      }
    }
    // this.csrfToken = response.data.token;
    console.log('csrfToken:'+this.csrfToken)
    this.checkLogin()
  },
  mounted() {

    // this.suggestions = this.loadAll();
    // var swiper = new Swiper(".swiper-container", {
    //   effect: "coverflow",
    //   grabCursor: true,
    //   centeredSlides: true,
    //   slidesPerView: "auto",
    //   coverflowEffect: {
    //     rotate: 0, //把旋转角度改为0度
    //     stretch: 0,
    //     depth: 100,
    //     modifier: 1,
    //     slideShadows: true,
    //   },
    //   loop: true,
    // });
    const wow = new WOW({
      boxClass: "wow", // animated element css class (default is wow)
      animateClass: "animated", // animation css class (default is animated)
      offset: 0, // distance to the element when triggering the animation (default is 0)
      mobile: true, // trigger animations on mobile devices (default is true)
      live: true, // act on asynchronously loaded content (default is true)
      callback: function (box) {
        // the callback is fired every time an animation is started
        // the argument that is passed in is the DOM node being animated
      },
      scrollContainer: null, // optional scroll container selector, otherwise use window,
      resetAnimation: true, // reset animation on end (default is true)
    });
    console.log(wow)
    wow.init();
    // this.echartinit();
  },
  methods: {
    
    checkLogin(){
        axios({
          method: 'get',
          url: '/api/api/projects/',
          headers:{
            'X-CSRFToken': this.csrfToken,
          },
        }).then(response => {
          if (response.status == 200) { // 已经为登录状态
            this.$Global.isLogin = true
          }
        }).catch(error=>{
          console.log('error')
          console.log(error)
          // this.$router.push({name:'Login'})
        })
      },
    showProjects(){
      if(this.$Global.isLogin==false){
        this.$router.push({name:'Login'})
      }
      else{
        this.$router.push({name:'Projects'})
      }
    }
  }
}
</script>

<style scoped>
html {
  padding: 0;
  margin: 0;
}

body {
  padding: 0;
  margin: 0;
  background: url("../assets/images/apple.jpg") no-repeat;
  background-size: cover;
}

.search {
  position: fixed;
  margin: 50vh 18vw;
  width: 80vw;
  top: 52vh;
  font-size: 8vh;
}

.el-button {
  /* background-color: #000;
  color: red; */
  min-width: 120px;
  min-height: 60px;
  position: absolute;
  top:60vh;
  left:27vw; 
  font-size: 20px;
  color: white;
  /* opacity: 80%; */
  /* background-color: #999; */
}
</style>
<style>
.page {
  padding: 0;
  margin: -8px;
  height: 100%;
  width: 100%;
  position:fixed;
  background-image: url("../assets/images/weiminghu.jpeg");
  background-size:cover;
}
.popper {
  margin-left: 15vw;
}

</style>